export const FLAGS = {
  TBT_GENERAL_ACCESS: 'urn:hsbc:cmb:gdocs:taxonomies:featureFlags:TBT:GeneralAccess:GDOCS',
  TBT_FORCE_GDOCS_ACCESS: 'urn:hsbc:cmb:gdocs:taxonomies:featureFlags:TBT:ForceGDocsAccess:GDOCS'
};

export const FEATURE_FLAGS_TAXONOMY = '/taxonomies/urn:hsbc:cmb:gdocs:taxonomies:featureFlags';
export const USER_FEATURE_FLAGS_URL = '/users/:userId/feature-flags';


// WEBPACK FOOTER //
// ./src/featureFlags/flags.js